import { useMutation, useQuery } from '@tanstack/react-query';
import { App, Button, Card, Divider, Flex, Select, Table } from 'antd';
import React, { useState } from 'react';
import Heading from '../../components/common/Heading/Heading';
import { getReconcillation } from '../../network/reconcillation';
import { getParties } from '../../network/PaymentEntry';
import { queryKeys } from '../../services/react-query/queryKeys';
import { useSelector } from 'react-redux';
import ReconcileColums from './ReconcileColums';
import { IoGitCompare } from 'react-icons/io5';
import { ModalAppReconciliation } from '../../components/upeosoft/ModalApp/ModalApp';
import DashboardCards from '../Dashboard/DashboardCards';

const Reconcillation = ({ t }) => {
  const { columnsPayment, columnsInvoice } = ReconcileColums({ t });
  const { companyName } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectPayment, setSelectPayment] = useState([]);
  const [selectInvoice, setSelectInvoice] = useState([]);
  const [slectedParty, setSelectedParty] = useState(null);
  const [dataParty, setDataParty] = useState({
    party: '',
    receivable_payable_account: '',
  });
  console.log(selectPayment, selectInvoice, 'selectPayment,selectInvoice');
  const { message } = App.useApp();

  const {
    mutate: onAddReconcillation,
    data: reconcillationData,
    reset,
  } = useMutation({
    mutationKey: ['onAddReconcillation'],
    mutationFn: (data) => getReconcillation(data),
    onSuccess: (data) => {
      console.log(data, 'data');
      setLoading(false);
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
    },
    onError: (error) => {
      console.log(error, 'error');
      setLoading(false);
    },
  });
  const handleFetchReconciliation = () => {
    setLoading(true);
    onAddReconcillation({
      method: 'get_unreconciled_entries',
      docs: {
        doctype: 'Payment Reconciliation',
        company: companyName,
        party_type: 'Customer',
        party: dataParty?.party,
        receivable_payable_account: dataParty?.receivable_payable_account,
      },
    });
  };
  const { data: partiesData } = useQuery({
    queryKey: [queryKeys.getParties],
    queryFn: () => getParties('Customer'),
  });
  const invoicesList = reconcillationData?.docs?.[0]?.invoices?.map(
    (item, index) => {
      return {
        ...item,
        key: item?.invoice_number,
      };
    }
  );
  const paymentsList = reconcillationData?.docs?.[0]?.payments?.map(
    (item, index) => {
      return {
        ...item,
        key: item?.reference_name,
      };
    }
  );
  return (
    <div className="">
      {/* <Heading title={t.Finance} subTitle={t.Reconcillation} path="/" /> */}
      <DashboardCards t={t} />
      <Card className="mt-5">
        <Flex
          align="center"
          justify="space-between"
          style={{ marginBottom: 20 }}
        >
          <Select
            //   loading={loadingParties}
            style={{ width: '180px' }}
            placeholder={'Please Select Party'}
            showSearch
            optionFilterProp="children"
            popupMatchSelectWidth={false}
            filterOption={(input, option) =>
              (option?.label ?? '').toLocaleLowerCase().includes(input)
            }
            //   disabled={isStatusDisabledFiled || !!sales}
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? '')
                .toLowerCase()
                .localeCompare((optionB?.label ?? '').toLowerCase())
            }
            onChange={(value, option) => {
              console.log('option:', option);
              setSelectPayment([]);
              setSelectInvoice([]);
              setLoading(true);
              setDataParty({
                party: value,
                receivable_payable_account: option?.data?.account_paid_to,
              });
              setSelectedParty(value);
              onAddReconcillation({
                method: 'get_unreconciled_entries',
                docs: {
                  doctype: 'Payment Reconciliation',
                  company: companyName,
                  party_type: 'Customer',
                  party: value,
                  receivable_payable_account: option?.data?.account_paid_to,
                },
              });
            }}
            //   onChange={onChangeAppointment}
            value={slectedParty}
            options={partiesData?.message?.parties?.map((user) => ({
              value: user?.name,
              label: user?.name,
              data: user,
            }))}
          />
          <Button
            type="primary"
            // ghost
            icon={<IoGitCompare />}
            onClick={() => setOpen(true)}
            disabled={!selectPayment?.length || !selectInvoice?.length}
          >
            {t.Reconcile}
          </Button>
        </Flex>
        <Divider
          style={{ margin: '10px 0' }}
          orientationMargin="0"
          orientation="left"
        >
          {t.PaymentsList}
        </Divider>
        <Table
          className="table_custom"
          columns={columnsPayment}
          dataSource={paymentsList}
          scroll={{ x: 'max-content' }}
          // className="table"
          pagination={{
            hideOnSinglePage: true,
          }}
          loading={loading}
          rowKey="key"
          rowSelection={{
            selectedRowKeys: selectPayment?.map((item) => item?.key),
            type: 'checkbox',
            onChange: (selectedRowKeys, selectedRows) => {
              // console.log(selectedRowKeys, selectedRows);
              setSelectPayment(selectedRows);
            },
          }}
        />
        <Divider
          style={{ margin: '10px 0' }}
          orientationMargin="0"
          orientation="left"
        >
          {t.InvoicesList}
        </Divider>
        {/* <h3 style={{margin:'5px 0'}} > {t.InvoicesList} </h3> */}
        <Table
          className="table_custom"
          columns={columnsInvoice}
          dataSource={invoicesList}
          scroll={{ x: 'max-content' }}
          // className="table"
          pagination={{
            hideOnSinglePage: true,
          }}
          loading={loading}
          rowKey="key"
          rowSelection={{
            selectedRowKeys: selectInvoice?.map((item) => item?.key),
            type: 'checkbox',
            onChange: (selectedRowKeys, selectedRows) => {
              // console.log(selectedRowKeys, selectedRows);
              setSelectInvoice(selectedRows);
            },
          }}
        />
      </Card>
      <ModalAppReconciliation
        t={t}
        open={open}
        setSelectedParty={setSelectedParty}
        setSelectPayment={setSelectPayment}
        setSelectInvoice={setSelectInvoice}
        reset={reset}
        setOpen={setOpen}
        dataParty={dataParty}
        selectPayment={selectPayment}
        selectInvoice={selectInvoice}
        handleFetchReconciliation={handleFetchReconciliation}
      />
    </div>
  );
};

export default Reconcillation;
